// Import dependencies
import { useEffect, useRef, useState } from "react";
// import components and configuration
import {
  TopHeader,
  GridLoader,
  AsideFilterLoader,
  Tabs,
} from "./component";
import {
  AuthWrapperCM as AuthWrapper,
  DropDown,
  TextField,
  TwoColumnLayout,
  Button,
  FeedbackPopup,
  DropDownMenu,
  DownloadPDFButton,
  DateField
} from "../../components";
import KendoGrid from "../../components/containers/kendo-grid";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteRecordById,
  editCaseRecordById,
  fetchCaseConfigByDSPId,
  fetchChildGridDataById,
  fetchCreateCase,
  fetchDSPId,
  fetchGridDataById,
  fetchPicklistById,
  resetAddNewCase,
  resetCaseConfigByDSPId,
  resetCreateCase,
  resetDeleteRecordById,
  resetEditCaseRecordById,
  resetFetchChildGridDataById,
  resetFetchDSPId,
  resetFetchGridDataById,
  resetFetchPicklistById,
} from "./store/actions";
import {
  GROUP_REF_SELETECTED,
  TOKEN,
  clearParticularStorage,
  clearStorage,
  getData,
  setData,
} from "../../utils/Storage";
import { toast } from "react-toastify";
import { Layout } from "../case-summary/components";
import InformationGovernanceWrapper from "../case-summary/components/InformationGovernanceWrapper";
import { useTranslation } from "react-i18next";
import { closeIcon, map_white, notification } from "../../assets/icons";
import dashboardService from "./services/dashboard-service";
import { REDIRECT_DOMAIN_NAME } from "../../config/ApiConstants";
import { infinityLoader } from "../../config/Images";
import {
  fetchFeedbackCSRequest,
  resetFeedbackCS,
  resetFetchHHC,
  resetUpdateData,
} from "../case-summary/store/actions";
import CustomAction from "./component/customAction";
import EditCasePopup from "./component/editCaseDataPopup";
import BulkActionPopup from "./component/bulkActionPopup";
import CommunityAssets from "../community-assets";
import { map, graph } from "../../assets/icons";
import CreateCasePopup from "../case-summary/components/CreateCasePopup";
import { bulkActionRequest, resetBulkAction } from "./store/bulkaction.slice";
import { bulkConfigActionRequest, resetBulkConfigAction } from "./store/bulkactionconfig.slice";
import { bulkDeleteActionRequest, resetBulkDeleteAction } from "./store/bulkdeleteaction.slice";
import { fetchAllPickerListRequest, resetFetchAllPickerList } from "./store/fetchAllPickerList.slice";
import SoftDeletePopup from "./component/softdeletpopup";
import GenerateMFAModal from "./component/GenerateMFAModal";
import Modal from "../../components/atoms/modal";

// Interface to type-check pagination states
interface PageState {
  skip: number;
  take: number;
}

const Dashboard = (props: any) => {
  const iframeEle = useRef<any>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const editCaseDataState = useSelector((state: any) => state.editCaseDetails);
  const dspCodes = useSelector((state: any) => state.dspCodes);
  const caseManagementConfig = useSelector((state: any) => state.caseManagementConfig);
  const getPickerListById = useSelector((state: any) => state.getPickerListById);
  const getPickerListAll = useSelector((state: any) => state.getPickerListAllData);

  const mainGridData = useSelector((state: any) => state.mainGridData);
  const childGridData = useSelector((state: any) => state.childGridData);
  const caseSummaryConfig: any = useSelector<any>((state) => state.caseSummaryConfigCM);
  const deleteRecordByIdData: any = useSelector<any>((state) => state.deleteRecordById);
  const hhcalertdata: any = useSelector<any>((state) => state.HHCAlert);
  const feedbackCslistdata: any = useSelector<any>((state) => state.feedbackCs);
  const overviewreferenceaccess: any = useSelector<any>((state) => state.overviewreferenceCM);
  const bulkActionConfigData: any = useSelector<any>((state) => state.bulkConfigActionSliceData);
  const bulkDeleteActionData: any = useSelector<any>((state) => state.bulkDeleteActionData);

  const editCaseDataRed = useSelector((state: any) => state.editCaseDetails);

  const caseData: any = useSelector<any>((state) => state.caseDataCM);
  const createCaseData = useSelector((state: any) => state.createCaseData);

  const bulkActionSliceData = useSelector((state: any) => state.bulkActionSliceData);

  const [caseSummaryType, setCaseSummaryType] = useState<any>(null);
  const [mainGridDataLoading, setMainGridDataLoading] = useState<any>(true);
  const [token, setToken] = useState<any>({ isLegacy: false, token: "" });
  const [selectedDSP, setSelectedDSP] = useState<any>(null);
  const [filterList, setFilterList] = useState<any>([]);
  const [showFeedbackpopup, setShowFeedbackpopup] = useState<boolean>(false);
  const [gridDataRows, setGridDataRows] = useState<any>([]);
  const [gridData, setGridData] = useState<any>(null);
  const [isCommunityAssets, setIsCommunityAssets] = useState<boolean>(false);
  const [isReferral, setIsReferral] = useState<boolean>(false);
  const [isCommunityAssetsEnabled, setIsCommunityAssetsEnabled] = useState<boolean>(true);
  const [createCaseStateData, setCreateCaseStateData] = useState<any>(null);
  const [createCaseshowModel, setCreateCaseshowModel] = useState<Boolean>(false);
  const [isBulkActionPopup, setIsBulkActionPopup] = useState<Boolean>(false);
  const [bulkActionData, setBulkActionData] = useState<any>(null);
  const [actionPicklistControlId, setActionPicklistControlId] = useState<Number>();

  const [selectedFilters, setSelectedFilters] = useState<any>([]);
  // Track errors for text fields by controlId
  const [filterErrors, setFilterErrors] = useState<{ [controlId: number]: string }>({});
  const [gridId, setGridId] = useState<any>(null);
  const [isShowFeedback, setIsShowFeedback] = useState<{
    apiEndpoint: string;
    visible: boolean;
    label: string;
  } | null>(null);
  const [isShowPrintButton, setIsShowPrintButton] = useState<{ label: string, visible: boolean } | null>(null);
  const [isCaseDetailedMode, setIsCaseDetailedMode] = useState<boolean>(false);
  const [selectedCase, setSelectedCase] = useState<any>(null);
  const [selectedCaseReference, setSelectedCaseReference] = useState<any>(null);

  const [editCasePopup, setEditCasePopup] = useState<any>(false);
  const [editCaseData, setEditCaseData] = useState<any>(null);

  const [isUsername, setIsUsername] = useState<any>("");
  const [demographicsData, setDemographicsData] = useState<any>(null);
  const [caseDataState, setCaseDataState] = useState<any>(null);

  const [HHCMessage, setHHCMessage] = useState<any>(null);

  const [reportLinks, setReportLinks] = useState<any>(null);
  const [selectedReport, setSelectedReport] = useState<any>(null);
  const [isReporting, setIsReporting] = useState<boolean>(false);

  const [selectedSCVId, setSelectedSCVId] = useState<any>(null);
  const [createCaseButtonData, setCreateCaseButtonData] = useState<any>(null);
  const [mfaQRButtonTitle, setMfaQRButtonTitle] = useState<any>(null);
  const [bulkActionSelection, setBulkActionSelection] = useState<any>([]);
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);

  const [isCohortsSelected, setIsCohortsSelected] = useState<any>({
    status: false,
    cohortId: "",
  });

  const [showSoftDeletePopup, setShowSoftDeletePopup] = useState(false);
  const [leftSidePanel, setLeftSidePanel] = useState<any>(null);
  const [mainSection, setMainSection] = useState<any>(null);

  const [generateMFA, setGenerateMFA] = useState<boolean>(false);
  const [isIGConfirmed, setIsIGConfirmed] = useState<boolean>(false);
  const [isBulkActionPending, setIsBulkActionPending] = useState<boolean>(false);
  const prevBulkActionFetchingRef = useRef<boolean>(false);

  const cohortFilterIdRef = useRef<number>(0);

  useEffect(() => {
    window.addEventListener("communityAssets", (event: any) => {
      setIsCommunityAssets(true);
      setIsReferral(true);
      if (event?.detail) {
        setSelectedSCVId(event?.detail?.selectedSCVId);
      }
    });

    try {
      setSelectedCaseReference(null);
      setSelectedCase(null);
      setIsCaseDetailedMode(false);
      // getData(TOKEN).then((res: any) => {
      //   let token;
      //   if (res?.provider === "msal") {
      //     token = { isLegacy: false, token: res.token };
      //   } else {
      //     token = { isLegacy: true, token: res.token };
      //   }

      //   setToken(token);
        if (selectedDSP === null) {
          dispatch(fetchDSPId(token));
        }
      // });
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, selectedDSP]);

  useEffect(() => {
    if (
      overviewreferenceaccess.isSuccess &&
      overviewreferenceaccess.data !== null
    ) {
      let data = overviewreferenceaccess.data;

      if (data.accessCaseSummaryFlag === 1) {
        setCaseSummaryType(data.caseSummaryTypeId);
      }
    }
  }, [overviewreferenceaccess]);

  useEffect(() => {
    // Process received Information Create case data
    try {
      if (createCaseData.isSuccess && createCaseData.data !== null) {
        setCreateCaseshowModel(true);

        fetchIframeUrlBlog(createCaseData.data);
        dispatch(resetCreateCase());
      } else if (createCaseData.isError) {
        toast.error(createCaseData?.data?.error?.data);
        dispatch(resetCreateCase());
        setCreateCaseshowModel(false);
      }
    } catch (e: any) {
      toast.error(e.message);
    }
  }, [createCaseData, dispatch]);

  useEffect(() => {
    if (editCaseDataRed.isSuccess && editCaseDataRed.data !== null) {
      dispatch(
        fetchGridDataById({
          token: token,
          param: {
            gridId: gridId,
            dspId: selectedDSP,
            filtersJson: __processFilterData(selectedFilters),
          },
        })
      );
    }
  }, [editCaseData, selectedDSP, token, gridId, selectedFilters, dispatch, editCaseDataRed]);

  useEffect(() => {
    // Only process if a bulk action was pending
    if (!isBulkActionPending) {
      prevBulkActionFetchingRef.current = bulkActionSliceData.isFetching;
      return;
    }

    const wasFetching = prevBulkActionFetchingRef.current;
    prevBulkActionFetchingRef.current = bulkActionSliceData.isFetching;

    if (bulkActionSliceData.isSuccess && bulkActionSliceData.data !== null) {
      const data = bulkActionSliceData.data;

      toast.success(data);
      setIsBulkActionPopup(false);
      setIsBulkActionPending(false);
      dispatch(resetBulkAction());

      setMainGridDataLoading(true);
      dispatch(
        fetchGridDataById({
          token: token,
          param: {
            gridId: gridId,
            dspId: selectedDSP,
            filtersJson: __processFilterData(selectedFilters),
          },
        })
      );

    } else if (bulkActionSliceData.isError) {
      toast.error(bulkActionSliceData?.data?.error || bulkActionSliceData?.error?.data || "An error occurred while processing the bulk action");
      setIsBulkActionPopup(false);
      setIsBulkActionPending(false);
      dispatch(resetBulkAction());
    } else if (wasFetching && !bulkActionSliceData.isFetching && !bulkActionSliceData.isSuccess && !bulkActionSliceData.isError) {
      // Handle edge case where request completed (isFetching went from true to false) 
      // but neither success nor error was set. This can happen if the saga fails silently.
      toast.error("An unexpected error occurred. Please try again.");
      setIsBulkActionPopup(false);
      setIsBulkActionPending(false);
      dispatch(resetBulkAction());
    }

  }, [bulkActionSliceData, selectedDSP, token, gridId, selectedFilters, dispatch, isBulkActionPending]);

  useEffect(() => {
    if (bulkDeleteActionData.isSuccess && bulkDeleteActionData.data !== null) {
      toast.success(bulkDeleteActionData.data);

      setMainGridDataLoading(true);
      dispatch(
        fetchGridDataById({
          token: token,
          param: {
            gridId: gridId,
            dspId: selectedDSP,
            filtersJson: __processFilterData(selectedFilters),
          },
        })
      );

      dispatch(resetBulkDeleteAction())
    } else if (bulkDeleteActionData.isError) {
      // Handle various error response structures
      const errorMessage = 
        bulkDeleteActionData.error?.data?.message ||
        "An error occurred while processing the bulk action";
      toast.error(typeof errorMessage === 'string' ? errorMessage : "An error occurred while processing the bulk action");
      dispatch(resetBulkDeleteAction())
    }
  }, [bulkDeleteActionData, selectedDSP, token, gridId, selectedFilters, dispatch])

  useEffect(() => {
    // Process received addOutcomeModel data
    if (bulkActionConfigData.isSuccess && bulkActionConfigData.data !== null) {
      const data = bulkActionConfigData.data;

      if (data.popupFormWrapper !== null) {
        setIsBulkActionPopup(true);
        setBulkActionData(data.popupFormWrapper);
      } else if (data.popupFormWrapper === null) {
        // Store the entire config data and show confirmation popup
        if (data.confirmation.validateCohort === true &&  isCohortsSelected.status !== true) {
          toast.error('Please apply a cohort to proceed');
        }else {
          setShowSoftDeletePopup(true);
          setBulkActionData(data);
        }
      }

      dispatch(resetBulkConfigAction());
    } else if (bulkActionConfigData.isError) {
      toast.error(bulkActionConfigData?.data?.error?.data);
      setIsBulkActionPopup(false);
      dispatch(resetBulkConfigAction());
    }
  }, [bulkActionConfigData, dispatch, isCohortsSelected]);

  useEffect(() => {
    try {
      if (dspCodes.isSuccess && dspCodes.data !== null) {
        setSelectedDSP(dspCodes.data.defaultSelectedValue);

        __fetchSelectedDSP(dspCodes.data.defaultSelectedValue);

        setSelectedCase(null);
        setSelectedCaseReference(null);
        setIsCaseDetailedMode(false);
        dispatch(resetFetchDSPId());
      } else if (dspCodes.isError) {
        dispatch(resetFetchDSPId());
      }
    } catch (e) {
      console.log(e);
    }
  }, [dspCodes, dispatch]);

  useEffect(() => {
    try {
      if (deleteRecordByIdData.isSuccess && deleteRecordByIdData.data !== null) {
        toast.success(deleteRecordByIdData.data.message ?? "Record deleted successfully");

        dispatch(
          fetchGridDataById({
            token: token,
            param: {
              gridId: gridId,
              dspId: selectedDSP,
              filtersJson: __processFilterData(selectedFilters),
            },
          })
        );

        dispatch(resetDeleteRecordById());
      } else if (deleteRecordByIdData.isError) {
        console.log(deleteRecordByIdData.data);
        toast.error("Something went wrong, please try again later");
        dispatch(resetDeleteRecordById());
      }
    } catch (e) {
      console.log(e);
    }
  }, [deleteRecordByIdData, selectedDSP, token, gridId, selectedFilters, dispatch]);

  useEffect(() => {
    if (caseManagementConfig.isSuccess && caseManagementConfig.data !== null) {
      setIsCommunityAssetsEnabled(caseManagementConfig.data.isCaIconVisible);
      setCreateCaseButtonData(caseManagementConfig.data.createCaseButton);
      setMfaQRButtonTitle(caseManagementConfig.data.mfaQRButtonCaption);

      const data = caseManagementConfig.data.panels;
      if (data[0].type === "Report") {
        setIsReporting(true);
        if (data && data.length > 0) {
          data.forEach((item: any) => {
            switch (item.panelId) {
              case 3:
                const flatList =
                  item.primarySections[0].form.controls[0].treeItems.items;
                const defaultSelected =
                  item.primarySections[0].form.controls[0].treeItems
                    .defaultSelectedValue;

                // Convert flat list to a lookup by parentId
                const buildLookup = (
                  items: any[]
                ): Map<string | null, any[]> => {
                  const lookup = new Map<string | null, any[]>();
                  items.forEach((item) => {
                    if (item.id === defaultSelected) {
                      setSelectedReport(item);
                    }
                    const children = lookup.get(item.parentId) || [];
                    children.push(item);
                    lookup.set(item.parentId, children);
                  });
                  return lookup;
                };

                setReportLinks(buildLookup(flatList));
                break;

              default:
                return null;
            }
          });
        }
      } else {
        setIsReporting(false);
        setIsUsername(caseManagementConfig.data.username);
        if (data && data.length > 0) {
          data.forEach((item: any) => {
            switch (item.panelId) {
              case 1:
                setLeftSidePanel(item);
                break;

              case 2:
                setMainSection(item);
                break;

              default:
                return null;
            }

            item.primarySections.forEach((section: any) => {
              let pikerLists: any = [];
              section?.form?.controls.forEach((field: any) => {
                if (field.type === "selectpicker") {
                  pikerLists.push(field.controlId)
                }

                const tempArray = [...filterList];
                const index = tempArray.findIndex((item: any) => {
                  return item.controlId === field.controlId;
                });

                if (index > -1) {
                  tempArray[index].values = [];
                } else {
                  setFilterList((prevState: any) => {
                    return [
                      ...prevState,
                      { ...field, values: [], panelID: item.panelId },
                    ];
                  });
                }
              });

              // Fetch all dropdown lists
              if (pikerLists.length > 0) {
                const obj: any = {
                  token: token,
                  param: {
                    controlIdsCsv: pikerLists.join(","),
                    dspId: selectedDSP
                  }
                }

                dispatch(fetchAllPickerListRequest(obj))
              }

              if (section.type === "datagrid") {
                setGridId(section.dataGrid.dataGridId);
                dispatch(
                  fetchGridDataById({
                    token: token,
                    param: {
                      gridId: section.dataGrid.dataGridId,
                      dspId: selectedDSP,
                      filtersJson: [],
                    },
                  })
                );
              }
            });
          });
        }
      }

      dispatch(resetCaseConfigByDSPId());
    } else if (caseManagementConfig.isError) {
      if (
        caseManagementConfig.data?.error?.response?.status === 404 &&
        REDIRECT_DOMAIN_NAME !== undefined
      ) {
        // if case management config not found redirect to case management domain
        window.location.replace(REDIRECT_DOMAIN_NAME);
      } else {
        toast.error("Something went wrong, please try again later");
      }

      dispatch(resetCaseConfigByDSPId());
    }
  }, [caseManagementConfig, selectedDSP, token, dispatch, filterList]);

  useEffect(() => {
    if (editCaseDataState.isSuccess && editCaseDataState.data !== null) {
      toast.success("Case Details updated successfully");

      setMainGridDataLoading(true);
      dispatch(
        fetchGridDataById({
          token: token,
          param: {
            gridId: gridId,
            dspId: selectedDSP,
            filtersJson: __processFilterData(selectedFilters),
          },
        })
      );

      dispatch(resetEditCaseRecordById());
    } else if (editCaseDataState.isError) {
      toast.error(editCaseDataState.data.error.message);
      dispatch(resetEditCaseRecordById());
    }
  }, [editCaseDataState, selectedDSP, token, gridId, selectedFilters, dispatch]);


  useEffect(() => {
    if (getPickerListById.isSuccess && getPickerListById.data !== null) {
      const data = getPickerListById.data;

      const newFilters = [...filterList];
      const index = newFilters.findIndex((item: any) => {
        return data.controlId === item.controlId;
      });

      if (index > -1) {
        newFilters[index].values = data.values;
        newFilters[index].defaultSelectedValue = data?.defaultSelectedValue;
        newFilters[index].selectedItem = null;
      }

      setFilterList(newFilters);

      dispatch(resetFetchPicklistById());
    } else if (getPickerListById.isError) {
      //TODO: investigate the issue, but suppress the error message for now
      //toast.error("Something went wrong, please try again later");
      dispatch(resetFetchPicklistById());
    }
  }, [getPickerListById, dispatch, filterList]);

  useEffect(() => {
    if (getPickerListAll.isSuccess && getPickerListAll.data !== null) {

      const data = getPickerListAll.data;

      const processedData = dashboardService.processAllDropdownPikerlistData(data.options, filterList);
      setFilterList(processedData);

      // Fetch PikerList individually if anything fails 
      if (data.invalidControlIds.length > 0) {
        console.log("Fetch api")
        data.invalidControlIds.map((res: any) => {
          dispatch(
            fetchPicklistById({
              token: token,
              param: {
                dspId: selectedDSP,
                controlId: res
              },
            })
          );
        })
      }

      dispatch(resetFetchAllPickerList());
    } else if (getPickerListAll.isError) {
      dispatch(resetFetchAllPickerList());
    }
  }, [getPickerListAll, dispatch, filterList, selectedDSP, token]);

  useEffect(() => {
    if (mainGridData.isSuccess === true && mainGridData.data !== null) {
      setMainGridDataLoading(false);
      const masterData = mainGridData.data;

      const data = dashboardService.processDataForKendoGrid(masterData);

      setGridData(data);
      setGridDataRows({ data: data.gridRows, total: data.rowCount });
      setBulkActionSelection([]);
      
      // Check if cohort filter is applied and update isCohortsSelected
      const cohortControlId = cohortFilterIdRef.current;
      if (cohortControlId && selectedFilters[cohortControlId]?.Values) {
        setIsCohortsSelected({
          status: true,
          cohortId: selectedFilters[cohortControlId].Values,
        });
      } 
      
      dispatch(resetFetchGridDataById());
    } else if (mainGridData.isError) {
      toast.error("Something went wrong, please try again later");
      dispatch(resetFetchGridDataById());
    }
  }, [mainGridData, dispatch, selectedFilters]);

  useEffect(() => {
    if (childGridData.isSuccess === true && childGridData.data !== null) {
      const childData = dashboardService.processDataForKendoGridChildData(
        childGridData.data
      );
      const indexOfInGridRowData = gridDataRows.data.findIndex(
        (item: any) => item.Group_Ref === childGridData.data.oneViewReference
      );
      if (indexOfInGridRowData !== -1) {
        let tempArray = [...gridDataRows.data];
        tempArray[indexOfInGridRowData].details = childData;
        setGridDataRows({ data: tempArray, total: gridDataRows.total });
      }
      dispatch(resetFetchChildGridDataById());
    } else if (childGridData.isError) {
      toast.error("Something went wrong, please try again later");
      dispatch(resetFetchChildGridDataById());
    }
  }, [childGridData, dispatch, gridDataRows]);

  useEffect(() => {
    // Process received case data
    try {
      if (caseData.data && caseData.data !== null) {
        setCaseDataState(caseData.data);
      }
    } catch (e: any) {
      toast.error(e.message);
    }
  }, [caseData]);

  useEffect(() => {
    // Process received case summary config data
    try {
      if (caseSummaryConfig.isSuccess && caseSummaryConfig.data !== null) {
        const data = caseSummaryConfig.data.panels;
        setIsShowFeedback(caseSummaryConfig.data.feedBackButton);
        setIsShowPrintButton(caseSummaryConfig.data.printCSButton);
        if (data && data.length > 0) {
          data.forEach((item: any) => {
            switch (item.title) {
              case "Demographics":
                setDemographicsData(item);
                break;

              default:
                return "none";
            }
          });
        }
      }
    } catch (e: any) {
      toast.error(e.message);
    }
  }, [caseSummaryConfig]);


  const fetchIframeUrlBlog = async (req: any) => {
    setCreateCaseStateData(null);
    try {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", req.url);
      xhr.withCredentials = true;
      xhr.responseType = "blob";
      xhr.setRequestHeader("Authorization", `Bearer ${req.headerToken}`);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // this.response is a Blob, because we set responseType above
            let blobUrl = URL.createObjectURL(xhr.response);
            setCreateCaseStateData(blobUrl);
          } else {
            console.error("XHR failed", xhr);
          }
        }
      };

      xhr.send();
    } catch (e: any) {

      console.log("error", e);
      toast.error("Something went wrong, please try again later");
    }
  }

  const feedbackCsApiCall = (token: any, oneViewReference_res: any) => {
    let body = {
      token: token,
      caseSummaryType: caseSummaryType,
      dspId: selectedDSP,
      oneViewReference: oneViewReference_res,
    };

    dispatch(fetchFeedbackCSRequest({ token: token, params: body }));
  };

  useEffect(() => {
    if (feedbackCslistdata.isSuccess && feedbackCslistdata.data !== null) {
      dispatch(resetFeedbackCS());
    } else if (feedbackCslistdata.isError) {
      toast.error(
        feedbackCslistdata.data.error.data ||
        feedbackCslistdata.data.error.status
      );
      dispatch(resetFeedbackCS());
    }
  }, [feedbackCslistdata, dispatch]);

  useEffect(() => {
    if (hhcalertdata.isSuccess === true && hhcalertdata.data !== null) {
      if (hhcalertdata.data.length > 0) {
        setHHCMessage(hhcalertdata.data);
      }
      dispatch(resetFetchHHC());
    } else if (hhcalertdata.isError) {
      setHHCMessage(null);
      dispatch(resetFetchHHC());
    }
  }, [hhcalertdata, dispatch]);

  const __fetchSelectedDSP = (selectedDSP: any) => {
    try {
      dispatch(fetchCaseConfigByDSPId({ dspId: selectedDSP, token: token }));
    } catch (e) {
      toast.error("Something went wrong, please try again later");
    }
  };

  const __callCreateCaseApi = async () => {
    try {
      dispatch(fetchCreateCase({
        token: token,
        param: { dspId: selectedDSP }
      }));
    } catch (e) {
      toast.error("Something went wrong, please try again later");
    }
  };


  const __setFilterTextValue = (e: any, controlId: number) => {
    setSelectedFilters((prevState: any) => ({
      ...prevState,
      [controlId]: {
        controlId: controlId,
        Values: e.value,
      },
    }));
  }

    const __setFilterDateValue = (e: any, controlId: number) => {
    setSelectedFilters((prevState: any) => ({
      ...prevState,
      [controlId]: {
        controlId: controlId,
        Values: e.target.value,
      },
    }));
  }

  const __setFilterValue = (e: any, controlId: number) => {

    // if (e.length > 0) {
    let value: any = "";

    if (e.value !== undefined) {
      value = e.value;
    } else {
      // if (e.length > 0) {
      value = e.map((val: any) => val.value).join(", ");
      // }
    }

    setSelectedFilters((prevState: any) => ({
      ...prevState,
      [controlId]: {
        controlId: controlId,
        Values: value,
      },
    }));
    // } 
  };

  const __onSubmitFilter = (e: any) => {
    e.preventDefault();
    
    // Validate text fields
    let hasError = false;
    const newErrors: { [controlId: number]: string } = {};
    filterList.forEach((field: any) => {
      if (field.type === 'text') {
        const value = selectedFilters[field.controlId]?.Values || '';
        const minLength = field.textBoxMinInputLength || 0;
        if (minLength > 0 && value.length > 0 && value.length < minLength) {
          newErrors[field.controlId] = `Minimum ${minLength} characters required.`;
          hasError = true;
        }
      }
    });

    setFilterErrors(newErrors);
    if (hasError) {
      toast.error('Please fix validation errors before submitting.');
      return;
    }

    setSelectedCaseReference(null);
    setSelectedCase(null);
    setIsCaseDetailedMode(false);
    setMainGridDataLoading(true);
    setBulkActionSelection([]);

    try {
      if (mainGridData.isFetching) {
        toast.error("Please wait, data is loading");
      } else {
        dispatch(
          fetchGridDataById({
            token: token,
            param: {
              gridId: gridId,
              dspId: selectedDSP,
              filtersJson: __processFilterData(selectedFilters),
            },
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const __processFilterData = (data: any) => {
    let tempArray = [];
    for (const item in data) {
      tempArray.push(data[item]);
    }
    return tempArray;
  };

  const __clearFilterData = () => {
    setSelectedFilters({});
    setFilterErrors({});
    setIsCohortsSelected({
      status: false,
      cohortId: "",
    });
    setMainGridDataLoading(true);

    const temp = [...filterList];
    temp.forEach((item: any) => {
      if (item.controlId !== 20) {
        item.defaultSelectedValue = "";
        item.selectedItem = null;
      }
    });
    setFilterList(temp);

    if (mainGridData.isFetching) {
      toast.error("Please wait, data is loading");
    } else {
      dispatch(
        fetchGridDataById({
          token: token,
          param: {
            gridId: gridId,
            dspId: selectedDSP,
            filtersJson: __processFilterData({}),
          },
        })
      );
    }
  };

  // Render aside layout
  const __renderCaseSummaryAside = () => {
    if (caseSummaryConfig.isFetching) {
      return (
        <div style={{ textAlign: "center" }}>
          <img src={infinityLoader} alt="loading" style={{ width: 40 }} />
        </div>
      );
    }

    return (
      <>
        <Layout
          data={demographicsData}
          caseData={caseDataState}
          isAside={true}
          onClickExpand={(id: string) => {
            console.log(id);
          }}
          onClickFetchCaseData={(dataId: string) => {
            // __fetchCaseDataAPI(dataId, onveViewReferenceId);
          }}
        />
      </>
    );
  };

  // function to render the aside filter
  const _renderFilterAside = () => {
    if (selectedCaseReference !== null) {
      return __renderCaseSummaryAside();
    }

    if (filterList.length === 0) {
      return null
    }

    let __renderFields: any = [];
    let __renderButtons: any = [];

    filterList?.forEach((field: any, index: number) => {

      if(field.name === "cohorts") {
        cohortFilterIdRef.current = field.controlId;
      }

      if (field.panelID === 1) {
        switch (field.type) {
          case "selectpicker":

            let selectedValue = '';

            if (selectedFilters[field.controlId]?.Values !== undefined) {
              selectedValue = selectedFilters[field.controlId]?.Values;
            } else {
              selectedValue = field.defaultSelectedValue !== undefined ? field.defaultSelectedValue : undefined;
            }

            __renderFields.push(
              <DropDown
                label={field.label}
                labelExternal={true}
                key={"filters" + index}
                name={field.name}
                data={field.values}
                defaultSelected={selectedValue}
                isMultiSelectPickList={field.isMultiSelectPickList}
                onChange={(e: any) => __setFilterValue(e, field.controlId)}
                hasTooltip={field.isHelpIconVisible}
                tooltipText={field.helpIconMessage}
              />
            );

            break;
          case "text":
            __renderFields.push(
              <TextField
                key={"text_field" + index}
                label={field.label}
                labelExternal={true}
                name={field.name}
                placeholder={field.placeholder}
                defaultSelected={selectedFilters[field.controlId]?.Values !== undefined ? selectedFilters[field.controlId]?.Values : ''}
                onChange={(e: any) => {
                  __setFilterTextValue(e, field.controlId);
                  // Clear error on change
                  if (filterErrors[field.controlId]) {
                    setFilterErrors((prev: any) => ({ ...prev, [field.controlId]: undefined }));
                  }
                }}
                hasTooltip={field.isHelpIconVisible}
                tooltipText={field.helpIconMessage}
                minLength={field.textBoxMinInputLength}
                error={filterErrors[field.controlId]}
              />
            );
            break;
          case 'datepicker': 
            __renderFields.push(
              <DateField 
              key={"text_field" + index}
              label={field.label}
              labelExternal={true}
              name={field.name}
              value={selectedFilters[field.controlId]?.Values || ''}
              onChange={(e: any) =>  __setFilterDateValue(e, field.controlId)}
              hasTooltip={field.isHelpIconVisible}
              tooltipText={field.helpIconMessage}
            />
            )
            break; 
          case "submit":
          case "reset":
            __renderButtons.push(
              <div>
                <Button
                  key={index}
                  title={field.label}
                  className={
                    field.type === "submit"
                      ? "btn-cta blue-background"
                      : "btn-cta transparent-background"
                  }
                  type={field.type}
                  onClick={() =>
                    field.type === "reset" ? __clearFilterData() : null
                  }
                  disabled={mainGridData.isFetching}
                />
              </div>
            );

            break;
          default:
            return null;
        }
      }
    });

    return (
      <div className="aside-filter-content" key={11}>
        {caseManagementConfig.isFetching ? (
          <AsideFilterLoader />
        ) : (
          <form method="get" onSubmit={(e) => __onSubmitFilter(e)}>
            <div className="filter-list-container">{__renderFields}</div>

            {/* action buttons for the aside fields  */}
            <div className="button-container">{__renderButtons}</div>
          </form>
        )}
      </div>
    );
  };

  const __fetchChildData = (e: any) => {
    try {
      if (e?.details === undefined) {
        dispatch(
          fetchChildGridDataById({
            token: token,
            param: {
              gridId: gridId,
              dspId: selectedDSP,
              oneViewReference: e.Group_Ref,
            },
          })
        );
      } else {
        const indexOfInGridRowData = gridDataRows.data.findIndex(
          (item: any) => item.Group_Ref === e.Group_Ref
        );
        if (indexOfInGridRowData !== -1) {
          let tempArray = [...gridDataRows.data];
          tempArray[indexOfInGridRowData].details = undefined;
          setGridDataRows({ data: tempArray, total: gridDataRows.total });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };


  const __onClickSoftDeleteAction = (res: any) => {
    try {
      // if (res.action === "details") {
      //   setIsCaseDetailedMode(true);
      //   setSelectedCase(res.data);
      //   setSelectedCaseReference(res.data.Group_Ref);
      //   setDemographicsData(null);
      //   setData(GROUP_REF_SELETECTED, { caseReference: res.data.Group_Ref })
      // }

        const obj: any = {
          token: token,
          url: bulkActionData.actionApiEndPoint.endpointUrl.replace("/api", ""),
          param: {
            ids: bulkActionSelection.join(", "),
            dspId: selectedDSP,
            controlId: actionPicklistControlId,
            cohortId: isCohortsSelected.cohortId,
          }
        }

        setShowSoftDeletePopup(false);
        dispatch(bulkDeleteActionRequest(obj))
      
    } catch (e) {
      console.log(e);
    }
  };


  const __onCustomAction = async (res: any) => {
    try {
      if (res.action === "details") {
        setIsCaseDetailedMode(true);
        setSelectedCase(res.data);
        setSelectedCaseReference(res.data.Group_Ref);
        setDemographicsData(null);
        setIsIGConfirmed(false); // Reset IG confirmation for new case
        setData(GROUP_REF_SELETECTED, 
          { caseReference: res.data.Group_Ref, 
            liquidLogicReference: res.data?.liquidLogicReference
          })
      } else if (res.action === "delete") {
        // const confirm = window.confirm("Are you sure you want to delete this record?");
        // confirm ?
        setMainGridDataLoading(true)
        dispatch(
          deleteRecordById({
            token: token,
            param: {
              gridId: gridId,
              dspId: selectedDSP,
              oneViewReference: res.data.Group_Ref,
            },
          })
        );
        // : null
      } else if (res.action === "edit") {
        setEditCasePopup(true);
        setEditCaseData(res.data);
        // const indexOfInGridRowData = gridDataRows.data.findIndex((item: any) => item.Group_Ref === e.dataItem.Group_Ref);
        // let tempArray = [...gridDataRows.data]
        // tempArray[indexOfInGridRowData].inEdit = true;

        // setGridDataRows({ data: tempArray, total: gridDataRows.total });
      }
    } catch (e) {
      console.log(e);
    }
  };



  const __IsCustomAction = (item: any) => {
    return true
  }

  const __renderCustomActionLayout = (res: any, gridOptions: any) => {
    return <CustomAction
      data={res}
      allowDetails={true}
      deleteLabel="Clear"
      allowEdit={gridOptions.allowEdit}
      allowDelete={gridOptions.allowDelete}
      onClick={(e: any) => __onCustomAction(e)}
    />
  }

  const getIcon = (iconName: string) => {
    switch (iconName) {
      case "map":
        return map;

      case "graph":
        return graph;

      default:
        return "";
    }
  };

  const __onReportClick = (item: any) => {
    if (
      item.parentId === 0 &&
      (item.reportLink === null ||
        item.reportLink === undefined ||
        item.reportLink === "")
    ) {
      return;
    }

    if (item.isEnabled) {
      setSelectedReport(item);
    } else {
      toast.error(item.disableClickMessage);
    }
  };

  const __printReport = () => {
    console.log("Print Report", selectedReport.reportLink);
    window.open(selectedReport.reportLink, "_blank");
    // iframeEle?.current.contentWindow.print();
  };

  const __renderList = (parentId: number, lookup: any) => {
    if (reportLinks === null) {
      return "";
    }

    const children = reportLinks.get(parentId);
    if (!children || children.length === 0) {
      return "";
    }

    let html = children.map((item: any, key: number) => {
      return (
        <li key={key} className={item.parentId === 0 ? "parent" : "child"}>
          <div className={item?.iconName ? "d-flex" : ""}>
            {item?.iconName ? (
              <div className="icon">
                <img
                  src={getIcon(item.iconName)}
                  alt={item.iconName}
                  width={30}
                />
              </div>
            ) : null}
            <div className="link">
              <button
                className={
                  "btn btn-link " +
                  (selectedReport?.id === item.id ? "active" : "") +
                  " " +
                  (item.parentId === 0
                    ? "parent"
                    : "child" +
                    " " +
                    (item.isEnabled === false ? "silveraccess" : ""))
                }
                onClick={() => __onReportClick(item)}
                disabled={
                  !item.isEnabled
                    ? false
                    : (item.reportLink === null ||
                      item.reportLink === undefined ||
                      item.reportLink === "") &&
                    item.parentId !== 0
                }
              >
                <span className={item.parentId === 0 ? "bold" : ""}>
                  {item.reportName}
                </span>
              </button>
            </div>
          </div>
          {__renderList(item.id, reportLinks)}
        </li>
      );
    });

    return <ul className="aside-report-list">{html}</ul>;
  };

  // function to render the aside filter
  const _renderFilterAsideReporting = () => {
    return (
      <div className="aside-reports-wrapper" key={11}>
        {caseManagementConfig.isFetching ? (
          <AsideFilterLoader />
        ) : (
          __renderList(0, reportLinks)
        )}
      </div>
    );
  };

  // function to render the section that incudes the filter and the serach bar
  const __renderMainSectionReporting = () => {
    return (
      <div className="filter-content pos-relative">
        <div className="filter-header">
          <h3>
            View Report{" "}
            {selectedReport !== null ? `- ${selectedReport.reportName}` : " "}
          </h3>

          <div className="button-list">
            <button
              className="btn btn-primary btn-border"
              disabled={selectedReport === null}
              onClick={() => __printReport()}
            >
              Print Report
            </button>
          </div>
        </div>
        <div className="content">
          {selectedReport !== null ? (
            <iframe
              ref={iframeEle}
              src={selectedReport.reportLink}
              width="100%"
              style={{ minHeight: "80vh" }}
              title="report-viewer"
            ></iframe>
          ) : (
            <div className="p-3 text-center" style={{ minHeight: "80vh" }}>
              Select Reports to View
            </div>
          )}
        </div>
      </div>
    );
  };

  const __bulkAction = (e: any) => {
    if (e === null) {
      return;
    }

    const newState: [] = e.filter((item: any) => item.SELECTED_FIELD === true).map((item: any) => item.Group_Ref);
    
    setBulkActionSelection(newState)
  }

  const __onClickActionPicklist = (e: any, controlId: any) => {
    const obj: any = {
      token: token,
      param: {
        dspId: selectedDSP,
        controlId: e.id,
      },
    }

    setActionPicklistControlId(e.id)
    dispatch(bulkConfigActionRequest(obj));
  }


  const __submitEditCaseRecord = (e: any) => {
    try {
      dispatch(
        editCaseRecordById({
          token: token,
          params: {
            controlId: gridId,
            dspId: selectedDSP,
            id: editCaseData.DgsId,
            oneViewReference: editCaseData.Group_Ref,
          },
          body: e,
        })
      );
    } catch (e) {
      toast.error("Something went wrong");
    }
  };

  // function to render the section that incudes the filter and the serach bar
  const __renderMainSection = () => {
    if (mainSection === null) {
      return null;
    }

    const mainData: any = [];
    const caseSummary: any = [];
    const mainGridToolbar: any = []

    mainSection.primarySections.forEach((item: any, index: number) => {
      switch (item.type) {
        case "datagrid":
          const toolbar = item.dataGrid.toolbar.controls[0];

          if (toolbar.visible) {
            let arrForDropdown = toolbar.picklistValues.map((obj: any) => {
              return {
                id: obj.valueToStore,
                title: obj.textToDisplay,
                value: obj.valueToStore
              }
            });

            mainGridToolbar.push(
              <div className="button-wrapper mx-1"
                style={{
                  width: "100%",
                  pointerEvents: bulkActionSelection.length === 0 ? 'none' : 'auto', opacity: bulkActionSelection.length === 0 ? 0.6 : 1,
                }}>
                <DropDownMenu
                  label={toolbar.label}
                  labelExternal={false}
                  key={"filters"}
                  name={"name"}
                  data={arrForDropdown}
                  defaultSelected={''}
                  isMultiSelectPickList={false}
                  onChange={(e) => __onClickActionPicklist(e, toolbar)}
                  hasTooltip={toolbar.isHelpIconVisible}
                  tooltipText={toolbar.helpIconMessage}
                />
              </div>
            );
          }

          mainData.push(
            gridData !== null ? (
              <KendoGrid
                gridData={gridData}
                isFilterable={item.dataGrid.isColumnFilterEnabled || false}
                filtersList={item.dataGrid.filters}
                isPaginated={true}
                onExpand={(e: any) => __fetchChildData(e)}
                expandField={item.dataGrid.hierarchy ? "details" : ""}
                selectedField="SELECTED_FIELD"
                onSelectionChange={__bulkAction}
                isCustomAction={__IsCustomAction(item)}
                customeActionLayout={(res: any) => __renderCustomActionLayout(res, item.dataGrid)}
                isShowAll={item.dataGrid.showAllColumns}
                isSelectable={{
                  enabled: true,
                  drag: false,
                  cell: false,
                  mode: 'multiple'
                }}
              />
            ) : null
          );
          break;

        case "tabs":
          // Check if IG is confirmed before rendering tabs
          if (!isIGConfirmed && selectedCaseReference) {
            caseSummary.push(
              <div key={index}>
                <InformationGovernanceWrapper
                  selectedCaseReference={selectedCaseReference}
                  dsp={selectedDSP}
                  onConfirmed={() => setIsIGConfirmed(true)}
                  onClose={() => {
                    setIsCaseDetailedMode(false);
                    setSelectedCaseReference(null);
                    setSelectedCase(null);
                    setHHCMessage(null);
                    setDemographicsData(null);
                    setCaseDataState(null);
                    dispatch(resetUpdateData());
                  }}
                />
              </div>
            );
          } else if (isIGConfirmed) {
            caseSummary.push(
              <div key={index}>
                <Tabs
                  tabs={item.tabs}
                  activeTab={0}
                  gridId={gridId}
                  overviewReferenceId={selectedCaseReference}
                  token={token}
                  dsp={selectedDSP}
                  onCloseCase={() => {
                    setIsCaseDetailedMode(false);
                    setSelectedCaseReference(null);
                    setSelectedCase(null);
                    setHHCMessage(null);
                    setDemographicsData(null);
                    setCaseDataState(null);
                    setIsIGConfirmed(false); // Reset IG confirmation
                    dispatch(resetUpdateData());
                  }}

                  onClickTab={(id: string) => {
                    // props.onClickFetchCaseData(id)
                  }}
                />
              </div>
            );
          }
          break;

        default:
          return null;
      }
    });

    return (
      <div>

        {/* dropdown option for filtering the case  */}
        {/* Hide grid only after IG is confirmed */}
        {!isIGConfirmed && (
          <div className="filter-content pos-relative">
            <div className="filter-header">
              <h3>
                {t("CASES")}{" "}
                <span className="">{`(${gridData !== null ? gridData.rowCount : 0} count)`}</span>
              </h3>
              {/* this is for the bulk button */}
              <div className="button-list">
                {/* 
                TODO: check kendo grid api 
                */}
                {/* <button
                  disabled={
                    mainGridData.isFetching ||
                    childGridData.isFetching
                  }
                  className="btn btn-primary btn-border"
                  onClick={() => {
                    document.dispatchEvent(exportToExcel);
                  }}
                >
                  Export
                </button>
                <div className="space"></div> */}


                {mainGridToolbar}
              </div>
            </div>
            <div className="content">
              {mainGridDataLoading ? (
                <div className="loader">{<GridLoader />}</div>
              ) : (
                mainData
              )}
            </div>

            {editCasePopup && (
              <EditCasePopup
                token={token}
                dspId={selectedDSP}
                data={editCaseData}
                controlId={gridId}
                closeModal={() => {
                  setEditCasePopup(false);
                  setEditCaseData(null);
                }}
                onSubmit={(e: any) => __submitEditCaseRecord(e)}
              />
            )}

            {selectedCaseReference !== null && !isIGConfirmed ? (
              <div className="overlay"></div>
            ) : null}
          </div>
        )}

        {
          <div className="filter-content case-details">
            <div
              className={
                selectedCaseReference !== null
                  ? "filter-header"
                  : "filter-header filter-disabled"
              }
            >
              <h3>
                {selectedCaseReference !== null
                  ? t("CASE_DETAILS_ID") + selectedCaseReference
                  : t("CASE_DETAILS")}

                {hhcalertdata.isSuccess && HHCMessage !== null ? (
                  <button
                    className="btn ms-3"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="New Notification"
                    onClick={() => setShowNotificationPopup(true)}
                    style={{
                      border: "1px solid #5464B0",
                      borderRadius: 15,
                      width: 25,
                      height: 25,
                      padding: 0,
                      background: "#ffffff",
                    }}
                  >
                    <img
                      src={notification}
                      alt="notification"
                      style={{ width: 14 }}
                    />
                  </button>
                ) : null}
              </h3>
              {isCaseDetailedMode ? (
                <div>
                  {
                    isShowPrintButton?.visible && 
                    <DownloadPDFButton 
                      className="btn btn-collapse btn-feedback mx-4"
                      data={isShowPrintButton}
                      onClick={(res:any) => {
                       
                      }}
                      fileName={`${selectedCaseReference}-CaseSummary.pdf`}
                      payload={{
                        oneviewReference: selectedCaseReference,
                        dspId: selectedDSP,
                        caseSummaryTypeId: caseSummaryType,
                      }}
                      label={isShowPrintButton.label}
                      />
                  }

                  {isShowFeedback?.visible && (
                    <button
                      className="btn btn-collapse btn-feedback"
                      onClick={() => {
                        feedbackCsApiCall(token, selectedCaseReference);
                        setShowFeedbackpopup(true);
                      }}
                    >
                      {isShowFeedback.label}
                    </button>
                  )}

                  <button
                    className="btn btn-transparent"
                    onClick={() => {
                      setIsCaseDetailedMode(false);
                      setSelectedCaseReference(null);
                      setSelectedCase(null);
                      setHHCMessage(null);
                      clearParticularStorage(GROUP_REF_SELETECTED);
                      setIsShowFeedback(null);
                      setIsShowPrintButton(null);
                      setDemographicsData(null);
                      setCaseDataState(null);
                      setIsIGConfirmed(false); // Reset IG confirmation
                      dispatch(resetUpdateData());
                    }}
                  >
                    <img src={closeIcon} alt="close" />
                  </button>
                </div>
              ) : null}

              <Modal title="Notification" show={showNotificationPopup} onClose={() => setShowNotificationPopup(false)}>
                <div className="notification-popup-content">
                  {HHCMessage}
                </div>
              </Modal>
            </div>

            {selectedCaseReference !== null ? (
              <div className="content">{caseSummary}</div>
            ) : null}
          </div >
        }
      </div >
    );
  };

  const __onClickCommunityAssets = () => {
    setIsCommunityAssets(!isCommunityAssets);
    setIsReferral(false);
  };

  const __onClickCreateCaseButton = () => {
    dispatch(resetAddNewCase());
    setCreateCaseshowModel(true);
  }

  const __onSubmitedCreateCase = (type: string, res: any) => {
    if (type === "refereshGrid") {
      dispatch(
        fetchGridDataById({
          token: token,
          param: {
            gridId: gridId,
            dspId: selectedDSP,
            filtersJson: __processFilterData(selectedFilters),
          },
        })
      );

      setCreateCaseshowModel(false);
    } else if (type === "createCase") {
      __callCreateCaseApi();
    } else {
      setCreateCaseshowModel(false);
    }
  }


  const __submitBulkAction = (type: string, data: any, url: string = "") => {
    try {
      if (type === null || type === "") {
        // Handle cancel and close actions
        setIsBulkActionPopup(false);
      } else if (type === "formSubmit") {
        /**
         * Dispatch action to Add outcome data
         **/
        let convertedArray: any = [];
        for (const key in data) {
          if (data[key] !== '') {
            convertedArray.push({
              "controlName": key,
              "values": data[key]
            })
          }
        }


        let obj: any = {
          token, url
        };

        // TODO: refactor this code as the select is temporary fix 
        if (convertedArray[0].controlName === "Select Cohort") {
          obj.param = {
            ids: bulkActionSelection.join(", "),
            dspId: selectedDSP,
            controlId: actionPicklistControlId,
            cohortId: convertedArray[0].values,
          }
        } else {
          obj.param = {
            oneViewReferences: bulkActionSelection.join(", "),
            dspId: selectedDSP,
            controlId: actionPicklistControlId,
            templateId: convertedArray[0].values
          }
        }

        setIsBulkActionPending(true);
        dispatch(bulkActionRequest(obj));


        // if (bulkActionData?.isDeleteConfirmation) {
        //   debugger
        //   // Handle delete confirmation
        //   if (isCohortsSelected.status === true) {
        //     const obj: any = {
        //       token: token,
        //       url: storedBulkActionConfig.actionApiEndPoint.endpointUrl.replace("/api", ""),
        //       param: {
        //         ids: bulkActionSelection.join(", "),
        //         dspId: selectedDSP,
        //         controlId: actionPicklistControlId,
        //         cohortId: isCohortsSelected.cohortId,
        //       }
        //     }
        //     dispatch(bulkDeleteActionRequest(obj));
        //     setIsBulkActionPopup(false);
        //   } else {
        //     toast.error("Please select cohort");
        //   }
        // }
      }
    } catch (e: any) {
      toast.error(e.message);
    }
  };


  const __changeDSP = (e: any) => {
    
      setSelectedDSP(e.value);
      setFilterList([]);
      setMainGridDataLoading(true);

      setIsCaseDetailedMode(false);
      setSelectedCase(null);
      setSelectedCaseReference(null);
      setDemographicsData(null);
      clearParticularStorage(GROUP_REF_SELETECTED);
      setHHCMessage(null);
      setIsIGConfirmed(false); // Reset IG confirmation on DSP change

      __fetchSelectedDSP(e.value);
      
      setSelectedFilters([]);
      setFilterErrors({});
      setIsCohortsSelected({
        status: false,
        cohortId: "",
      });
    
  }

  return (
    // dashboard component
    <AuthWrapper>
      <div className="dashboard">
        {/* header component  */}
        <TopHeader
          username={isUsername}
          isReporting={isReporting}
          createCaseButton={createCaseButtonData}
          mfaQRButtonTitle={mfaQRButtonTitle}
          onCreateCaseClick={() => __onClickCreateCaseButton()}
          onChange={__changeDSP}
          onGenerateMFA={() => setGenerateMFA(true)
          }
        />
        {createCaseshowModel && (
          <CreateCasePopup
            token={token}
            dspId={selectedDSP}
            data={createCaseButtonData}
            iframeData={createCaseStateData}
            isFetching={false}
            onSubmit={(type: string, res: any) => __onSubmitedCreateCase(type, res)}
          />
        )}

        {/* two TwoColumnLayout for dashboard */}

        {isReporting ? (
          <TwoColumnLayout
            asideTitle={t("Reports")}
            aside={_renderFilterAsideReporting()}
            main={__renderMainSectionReporting()}
          />
        ) : (
          <TwoColumnLayout
            asideTitle={selectedCaseReference === null ? t("Filter") : ""}
            aside={_renderFilterAside()}
            main={__renderMainSection()}
          />
        )} 

        {isCommunityAssets && (
          <CommunityAssets
            dsp={selectedDSP}
            group_reference={selectedCase?.Group_Ref}
            postcode={selectedCase?.Postcode}
            selectedSCVId={selectedSCVId}
            isReferral={isReferral}
            token={token}
            onClose={() => setIsCommunityAssets(!isCommunityAssets)}
          />
        )}

        {isBulkActionPopup && (
          <BulkActionPopup
            token={token}
            dspId={selectedDSP}
            title={"Bulk Action"}
            data={bulkActionData}
            selectedCaseReference={bulkActionSelection}
            onSubmit={__submitBulkAction}
          />)}

        {generateMFA && (
          <GenerateMFAModal
            token={token}
            onClose={() => {
              setGenerateMFA(!generateMFA)}
            }
          />)}

        {showSoftDeletePopup && (
          <SoftDeletePopup
            title={bulkActionData.confirmation.title}
            message={bulkActionData.confirmation.message}
            onClose={() => setShowSoftDeletePopup(false)}
            onConfirm={(e: any) => __onClickSoftDeleteAction(e)}
          />
        )}

        {showFeedbackpopup && (
          <FeedbackPopup
            dsp={selectedDSP}
            caseSummaryType={caseSummaryType}
            sectionId={props.sectionId}
            selectedCaseReference={selectedCaseReference}
            title={"Feedback"}
            onClose={() => setShowFeedbackpopup(false)}
            onOpen={() => {
              setShowFeedbackpopup(false);
            }}
          />
        )}

        {/* TODO: section for the map  */}
        {!isCommunityAssets && isCommunityAssetsEnabled && (
          <div className="community-assets-btn">
            <button
              onClick={__onClickCommunityAssets}
              className="btn btn-primary map"
              aria-current="page"
            >
              <img src={map_white} alt="map" />
            </button>
          </div>
        )}
      </div>
    </AuthWrapper>
  );
};

export default Dashboard;
